export const ApplicationDecisionFun = (
  reviewOption: any,
  recommendationOption: any
) => {
  if (reviewOption) {
    return reviewOption;
  } else if (recommendationOption) {
    return recommendationOption;
  }
  return "";
};
